import { List } from '@zxing/library/esm/customTypings';
import { SupplementaryEquipment } from './../../../../../tmc-visit/tmc-visit.model';
import { ParameterType } from './parameter-type.enum';
import { DictionaryEntry } from '@sdbn/common';

export class SupplementaryEquipmentDetails {
    id: number;
    name: DictionaryEntry;
    singleUse: boolean;
    parameter1: DictionaryEntry;
    parameter1Type: ParameterType;
    parameter2: DictionaryEntry;
    parameter2Type: ParameterType;
    parameter3: DictionaryEntry;
    parameter3Type: ParameterType;

    identifiers: List<SupplementaryEquipmentIdentifier>;
}

export class SupplementaryEquipmentIdentifier{
  identifier: string;
  active: boolean;

  constructor(data?: any) {
    if (data) {
      this.identifier = data.identifier;
      this.active = data.active;
    }
  }
}
